export default {
      id: "icon-close-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#icon-close",
      toString: function () {
        return this.url;
      }
    }